import { DateTimeFormats } from "highcharts";


export class ChartPoint
{
    //  x:number;
    //  y:string;
    constructor(public y:any,public x:any)
    {}
    // constructor(public y:number)
    // {}
}